import { GetServerSideProps } from 'next';
import { Fragment } from 'react';

import { wrapper } from 'src/redux/store/store';
import { getSimplePage } from 'src/api/pageApi';
import { PageSetUpInStorageConfig, ServerSideRenderingContext } from 'types/objectTypes';
import { CustomerType } from 'constants/enums';
import { calculateCustomerType } from 'lib/session.service';
import { extractSlug, setUpPageInStore } from 'lib/page.service';
import withMiddleware, { commonMiddleware, postCommonMiddleware } from 'src/shared/lib/middleware/combiner';
import { setDefaultCacheBehavior } from 'lib/storage.service';

const handler = async ({
  // @ts-ignore
  locale,
  path,
  req,
  res,
  store,
  preview = false,
}: ServerSideRenderingContext): Promise<any> => {
  const session = req?.session?.getSession();
  const customerType = calculateCustomerType(req.session);
  const isAuthorized = customerType === CustomerType.EC;

  try {
    const slug = extractSlug(req.url, locale);

    if (!slug) {
      return { notFound: true };
    }

    const page = await getSimplePage({ slug, customerType, preview, path });

    if (!page) {
      return { notFound: true };
    }

    const pageSetUpConfig: PageSetUpInStorageConfig = {
      page,
      session,
      slug,
      store,
      headers: req.headers,
      isAuthorized,
    };
    setUpPageInStore(pageSetUpConfig);
    setDefaultCacheBehavior(600, res);

    return { props: {} };
  } catch (e) {
    console.error(e);

    return { props: {} };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
// @ts-ignore
  .getServerSideProps(withMiddleware(
    handler,
    { prior: commonMiddleware, post: postCommonMiddleware },
  ));

export default Fragment;
